// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1x5Pl","rightAdornment":"Header_rightAdornment__34cfd"};